import { Box, Button, Tooltip } from "@mui/material"
import { alpha } from "@mui/material/styles"
import { WW_BLUE, PANEL_TEXT_MUTED } from "@/theme/tokens"

// Segmented option pill (Auto/Manual, On/Off, …) shared by the panels.
// options: [{ value, label, disabled?, tooltip? }] — the active value gets
// the white raised chip; a disabled option shows its tooltip on hover.
export default function SegmentedPill({ options, value, onChange, fullWidth = false }) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        p: 0.35,
        borderRadius: "999px",
        bgcolor: alpha(WW_BLUE, 0.08),
        gap: 0.35,
        flexShrink: 0,
        ...(fullWidth ? { width: "100%", boxSizing: "border-box" } : {}),
      }}
    >
      {options.map((option) => {
        const active = option.value === value
        const button = (
          <Button
            key={String(option.value)}
            aria-disabled={option.disabled || undefined}
            onClick={() => !option.disabled && onChange(option.value)}
            sx={{
              minWidth: 0,
              ...(fullWidth ? { flex: 1 } : {}),
              px: 1.2,
              py: 0.4,
              borderRadius: "999px",
              textTransform: "none",
              fontSize: "12px",
              fontWeight: 700,
              color: active ? WW_BLUE : PANEL_TEXT_MUTED,
              bgcolor: active ? "white" : "transparent",
              boxShadow: active
                ? "0 4px 10px rgba(18, 52, 86, 0.12)"
                : "none",
              ...(option.disabled
                ? { opacity: 0.45, cursor: "not-allowed" }
                : {}),
            }}
          >
            {option.label}
          </Button>
        )
        // aria-disabled instead of disabled so the tooltip still fires.
        return option.tooltip ? (
          <Tooltip key={String(option.value)} title={option.tooltip} placement="top">
            {button}
          </Tooltip>
        ) : (
          button
        )
      })}
    </Box>
  )
}
